import template from './Welcome.svelte'

export default (parent, stateRouter) => {
    const name = `${parent}.welcome`

    stateRouter.addState({
        name,
        route: '/welcome',
        template,
        activate: ({ domApi: component, parameters: { schoolId } }) => {
            component.$on('continueClicked', () => {
                stateRouter.go(`tab.task.generalInfo`, { schoolId })
            })
        }
    })
}
